






























































































import { Component } from 'vue-property-decorator'
import _ from 'lodash'
import { Getter, Action } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IPatient, IPatientType } from '@/store/modules/views/patient/states'
import { ICenter } from '@/store/modules/views/center/states'
import { IJob } from '@/store/modules/views/job/states'

@Component
export default class Patient extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }
  private id = ''
  private name = ''
  private email = ''
  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private editDialog = false
  private deleteDialog = false
  private resetDialog = false
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Action('patient/getPatientList')
  private getPatientList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('job/getJobList')
  private getJobList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
      includes: string,
    },
  }) => void

  @Getter('job/itemLists')
  private jobList!: IJob[]

  @Getter('patient/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('patient/itemLists')
  private itemLists!: IPatient[]

  @Getter('patient/pagination')
  private pagination!: {
    itemCount: number,
    page: number,
    pageCount: number,
  }

  @Getter('patient/patientTypeById')
  private patientTypeById!: {[patientTypeId: string]: IPatientType}

  // @Getter('center/centerById')
  // private centerById!: {[centerId: string]: ICenter}

  @Action('patient/getPatientTypeList')
  private getPatientTypeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  private async callApi(lists) {
    await lists({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
      },
    })
  }

  private async getPatientTypes() {
    await this.getPatientTypeList({
      headers: {
        page: 1,
        limit: 9999,
        sortBy: 'createdAt',
        sortDesc: false,
        search: Buffer.from('').toString('base64'),
        filter: Buffer.from('{}').toString('base64'),
      },
    })
  }

  private async getPatients() {
    this.loadingDataTable = true
    await this.callApi(this.getPatientList)
    const filter = {
      _id: [{
        condition: 'is',
        value: _.map(this.items, '_id'),
      }],
    }
    await this.getJobList({
      headers: {
        page: 1,
        limit: this.paginationLists.itemCount,
        sortBy: '_id',
        sortDesc: false,
        search: Buffer.from('').toString('base64'),
        filter: Buffer.from(JSON.stringify(filter)).toString('base64'),
        includes: '-',
      },
    })
    this.loadingDataTable = false
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(() => this.getPatients(), 1000)
    // this.clearTimeoutValue = setTimeout(() => Promise.all([this.getPatientTypes(), this.getPatients()]), 1000)
  }

  private async getList() {
    await Promise.all([this.getPatientTypes(), this.getPatients()])
  }

  private openDialog(patient: {name: string, email: string, id: string}, modelDialog: 'editDialog' | 'resetDialog' | 'deleteDialog') {
    this.currentData = _.cloneDeep(patient)
    this[modelDialog] = true
  }

  private addNewPatientDialog() {
    this.createDialog = true
  }

  private async created() {
    await this.getList()
  }

  private mapAddressText(text: IPatient['address']) {
    return this.mapAddress(text)
  }

  get route() {
    return _.includes(this.$route.fullPath, 'Assessment')
  }

  get jobByPatient() {
    return _.groupBy(this.jobList, 'patientId')
  }
}
